import { FC } from 'react'
import cn from 'classnames'
import { LinkButton } from 'components/extend/Link'
import { PlaceholderCell } from 'components/extend/PlaceholderCell'
import { IconTooltipInformation } from 'components/IconTooltip'
import { formatDateToMoscow } from 'helpers/dates'
import { TTrackingItem } from 'modules/order/types'

import { OrderTrackingBlockProps } from './types'

import s from './styles.module.less'

export const OrderTrackingBlock: FC<OrderTrackingBlockProps> = (props) => {
  const {
    isLoading,
    isTrackingLoading,
    departureDate,
    departurePoint,
    destinationDate,
    destinationPoint,
    barcode,
    tracking,
    onOpenModalTerminal,
    isShowFullInfo = true,
    destinationCourierDate
  } = props
  const empty = <>Информация в&nbsp;настоящий момент недоступна.</>

  const formatTime = (time: string | undefined) => {
    if (time) {
      return time.split(':').slice(0, 2).join(':')
    }

    return ''
  }

  return (
    <div className={s.orderTrackingBlock} data-test-id="order--tracking--block">
      <div className={s.start}>
        <div className={s.departureDate}>
          {!isLoading ? (
            <div className={s.date}>{formatDateToMoscow(departureDate)}</div>
          ) : (
            <PlaceholderCell height={24} />
          )}
          {!isLoading ? <div className={s.text}>Планово</div> : <PlaceholderCell height={24} />}
        </div>
        <div className={s.departurePoint}>
          <div className={s.primaryBlock}>
            {!isLoading ? (
              <div className={s.city}>{departurePoint?.terminal.name}</div>
            ) : (
              <PlaceholderCell height={24} />
            )}
            {!isLoading ? (
              <div className={s.terminalAddress}>
                {departurePoint?.isCourier ? departurePoint?.addressDetail?.address : departurePoint?.terminal.address}
              </div>
            ) : (
              <PlaceholderCell height={24} />
            )}
          </div>
          <div className={s.secondaryBlock}>
            {!isLoading ? (
              <>
                <div className={cn(s.status, departurePoint?.isCourier ? s.statusIsCourier : '')}>
                  {departurePoint?.isCourier
                    ? 'Заберёт курьер'
                    : isShowFullInfo && (
                        <LinkButton className={s.scheduleBtn} onClick={() => onOpenModalTerminal('departure')}>
                          Режим работы
                        </LinkButton>
                      )}
                </div>
                {departurePoint?.isCourier && departurePoint.delivery ? (
                  <div className={cn(s.status, departurePoint?.isCourier ? s.statusIsCourier : '', s.delivery)}>
                    {formatDateToMoscow(departurePoint.delivery.delivery?.date)}{' '}
                    {formatTime(departurePoint.delivery.delivery?.timeFrom)} –{' '}
                    {formatTime(departurePoint.delivery.delivery?.timeTo)}
                    <IconTooltipInformation placement="right" size="xs">
                      {departurePoint.delivery.courier ? (
                        <>
                          Ваш курьер:
                          <br />
                          {departurePoint.delivery.courier.name}
                        </>
                      ) : (
                        'В ближайшее время назначим первого освободившегося сотрудника'
                      )}
                    </IconTooltipInformation>
                  </div>
                ) : (
                  ''
                )}
              </>
            ) : (
              <PlaceholderCell height={24} />
            )}
            {/* <div className={s.terminalName}>{departurePoint?.terminal.name}</div> terminal name  */}
          </div>
          {/* eslint-disable-next-line */}
          {!isLoading ? (
            departurePoint?.addressDetail?.comment ? (
              <div className={cn(s.addressComment, 'break-words')}>{departurePoint?.addressDetail?.comment}</div>
            ) : (
              ''
            )
          ) : (
            <PlaceholderCell height={24} />
          )}
        </div>
      </div>
      <div className={s.history}>
        {/* eslint-disable-next-line */}
        {!isLoading && !isTrackingLoading ? (
          <>
            {/* eslint-disable-next-line */}
            <div className={cn(s.date, s.trackingProgress)}></div>
            {barcode ? (
              <div className={cn(s.historyPoint, '')}>
                <div className="flex w-full flex-col gap-1">
                  {tracking?.tracking.length
                    ? tracking?.tracking.map((el: TTrackingItem, index: number) => (
                        <div key={index} className="flex w-full flex-col justify-between gap-x-4 md:flex-row">
                          <div className={cn('text-body-md', index + 1 === tracking.tracking.length && 'text-primary')}>
                            {el.statusName}
                          </div>
                          <div className="whitespace-nowrap text-body-md text-on-surface-variant">
                            {formatDateToMoscow(el.dateTime, true)}
                          </div>
                        </div>
                      ))
                    : empty}
                </div>
                {tracking?.destinationDate ? (
                  <div className="mt-1 flex w-full flex-col justify-between gap-x-4 md:flex-row">
                    <div className="text-body-md">Поступление груза на терминал выдачи</div>
                    <div className="whitespace-nowrap text-body-md text-on-surface-variant">
                      {formatDateToMoscow(tracking?.destinationDate, false)}
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            ) : (
              <div className={s.divider}></div> //eslint-disable-line
            )}
          </>
        ) : (
          <PlaceholderCell height={90} />
        )}
      </div>
      <div className={s.end}>
        <div className={s.destinationDate}>
          {!isLoading ? (
            <div className={s.date}>{formatDateToMoscow(destinationDate)}</div>
          ) : (
            <PlaceholderCell height={24} />
          )}
          {!isLoading ? <div className={s.text}>Планово</div> : <PlaceholderCell height={24} />}
        </div>
        <div className={s.destinationPoint}>
          <div className={s.primaryBlock}>
            {!isLoading ? (
              <div className={s.city}>{destinationPoint?.terminal.name}</div>
            ) : (
              <PlaceholderCell height={24} />
            )}
            {!isLoading ? (
              <div className={s.terminalAddress}>
                {destinationPoint?.isCourier
                  ? destinationPoint?.addressDetail?.address
                  : destinationPoint?.terminal.address}
              </div>
            ) : (
              <PlaceholderCell height={24} />
            )}
          </div>
          <div className={s.secondaryBlock}>
            {!isLoading ? (
              <>
                <div
                  className={cn(
                    'text-body-md text-[#1a1c1e]',
                    destinationPoint?.isCourier
                      ? 'mb-1 inline-block rounded border border-solid border-[#c7c6ca] px-2 py-0.5'
                      : ''
                  )}
                >
                  {destinationPoint?.isCourier
                    ? 'Доставит курьер'
                    : isShowFullInfo && (
                        <LinkButton className={s.scheduleBtn} onClick={() => onOpenModalTerminal('destination')}>
                          Режим работы
                        </LinkButton>
                      )}
                </div>
                {destinationPoint?.isCourier && destinationCourierDate && (
                  <div className="mb-1 inline-block rounded border border-solid border-[#c7c6ca] px-2 py-0.5 text-body-md text-[#1a1c1e]">
                    {`${formatDateToMoscow(destinationCourierDate)} (планово)`}
                  </div>
                )}
                {destinationPoint?.isCourier && destinationPoint.delivery ? (
                  <div className={cn(s.status, destinationPoint?.isCourier ? s.statusIsCourier : '', s.delivery)}>
                    {formatDateToMoscow(destinationPoint.delivery.delivery?.date)}{' '}
                    {formatTime(destinationPoint.delivery.delivery?.timeFrom)} –{' '}
                    {formatTime(destinationPoint.delivery.delivery?.timeTo)}
                    <IconTooltipInformation placement="right" size="xs">
                      {destinationPoint.delivery.courier ? (
                        <>
                          Ваш курьер:
                          <br />
                          {destinationPoint.delivery.courier.name}
                        </>
                      ) : (
                        'В ближайшее время назначим первого освободившегося сотрудника'
                      )}
                    </IconTooltipInformation>
                  </div>
                ) : (
                  ''
                )}
              </>
            ) : (
              <PlaceholderCell height={24} />
            )}
            {/* <div className={s.terminalName}>{destinationPoint?.terminal.name}</div> terminal name  */}
          </div>
          {/* eslint-disable-next-line */}
          {!isLoading ? (
            destinationPoint?.addressDetail?.comment ? (
              <div className={cn(s.addressComment, 'break-words')}>{destinationPoint?.addressDetail?.comment}</div>
            ) : (
              ''
            )
          ) : (
            <PlaceholderCell height={24} />
          )}
        </div>
      </div>
    </div>
  )
}
